export default "__VITE_ASSET__CnYmw_pX__"